'use client';

import OpenOrdersTable from '../OpenOrdersTable/OpenOrdersTable';
import OpenPositionsTable from '../PositionsTable/OpenPositionsTable';
import UserBalancesPortfolioTable from '../UserBalancesPortfolioTable/UserBalancesPortfolioTable';
import MarginInfo from '../MarginInfo/MarginInfo';
import UnrealizedPnlTable from '../UnrealizedPnlTable';
import V2TradeHistoryTable from '../HistoryTables/V2TradesHistoryTable';
import TradePageOrderHistoryTable from '../HistoryTables/TradePageOrderHistoryTable/TradePageOrderHistoryTable';
import PositionHistoryTable from '../HistoryTables/PositionHistoryTable/PositionHistoryTable';
import { PORTFOLIO_HISTORY_MARKET_FILTER_ALL_OPTION } from 'src/components/PortfolioPage/PortfolioHistorySubPage/consts';

export const TradePageTableContent = ({
	activeTab,
	overviewPage,
}: {
	activeTab: string;
	overviewPage?: boolean;
}) => {
	switch (activeTab) {
		case 'tradeHistory':
			return <V2TradeHistoryTable page="trade" isLive />;
		case 'openOrders':
			return <OpenOrdersTable />;
		case 'balances':
			return (
				<UserBalancesPortfolioTable
					expanded={false}
					location={overviewPage ? 'portfolio-page' : 'trade-page'}
				/>
			);
		case 'unsettled':
			return <UnrealizedPnlTable />;
		// Account tab display on mobile + tablet.
		case 'account':
			return <MarginInfo />;
		case 'orderHistory':
			return <TradePageOrderHistoryTable />;
		case 'positionHistory':
			return (
				<PositionHistoryTable
					marketFilter={PORTFOLIO_HISTORY_MARKET_FILTER_ALL_OPTION.ticker}
				/>
			);
		default:
			return <OpenPositionsTable overviewPage={overviewPage} />;
	}
};
